module.exports = __webpack_public_path__ + "img/Imagen 8.0a2dc0a7.jpg";